// prettier-ignore
type SubProjection<Schema> = {
  [key in keyof Schema]?: Schema[key] extends Date ? boolean
    : Schema[key] extends Array<infer S> ? SubProjection<S> | boolean
    // : Schema[key] extends ObjectID ? boolean
    : Schema[key] extends object ? SubProjection<Schema[key]> | boolean
    : boolean;
};

// prettier-ignore
export type Projection<Schema> =
  | ({ __projectionType__: 'exclusive' | 'inclusive' } & SubProjection<Schema>)
  | {};

type InclusiveProjection = {__projectionType__: 'inclusive'};
type ExclusiveProjection = {__projectionType__: 'exclusive'};
type ExplicitProjection = InclusiveProjection | ExclusiveProjection;

// prettier-ignore
export type ApplyProjection<Schema, P extends Projection<Schema>> = 
  | {} extends P ? Schema : 
    P extends InclusiveProjection ? ApplyInclusiveProjection<Schema, P> :
    P extends ExclusiveProjection ? ApplyExclusiveProjection<Schema, P> :
    ApplyInclusiveProjection<Schema, P>; // Default to inclusive projection

// Removes all keys which have type never.  This is a hack because TS doesn't
// automatically remove them...
type StripNever<T> = Pick<
  T,
  {[K in keyof T]: T[K] extends never ? never : T[K] extends never | undefined ? never : K}[keyof T]
>;

// TODO: Replace these implementations with ones that rely on Pick if possible.
// Should create cleaner types & not be weird with optional keys
// prettier-ignore
type ApplyInclusiveProjection<S, P extends SubProjection<S>> = StripNever<{
  [key in keyof S]:
      P[key] extends true ? S[key]
    : S[key] extends Array<infer A> ? (P[key] extends object ? Array<ApplyInclusiveProjection<A, P[key]>> : never)
    : P[key] extends object ? ApplyInclusiveProjection<S[key], P[key]>
    : never;
}>;

// prettier-ignore
type ApplyExclusiveProjection<S, P extends SubProjection<S>> = StripNever<{
  [key in keyof S]:
     P[key] extends true ? never
    : S[key] extends Array<infer A> ? (P[key] extends object ? Array<ApplyExclusiveProjection<A, P[key]>> : S[key])
    : P[key] extends object ? ApplyExclusiveProjection<S[key], P[key]>
    : S[key]
}>;

export function isProjectionInclusive<P extends Projection<any>>(projection: P): boolean {
  return (projection as ExplicitProjection).__projectionType__ !== 'exclusive';
}

export function exclusiveProjection<Schema, P extends SubProjection<Schema>>(projection: P) {
  return {
    __projectionType__: 'exclusive',
    ...projection,
  } as const;
}

export function inclusiveProjection<
  Schema,
  P extends SubProjection<Schema> = SubProjection<Schema>
>(projection: P) {
  return {
    __projectionType__: 'inclusive',
    ...projection,
  } as const;
}
